import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Switch from "@mui/material/Switch";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import curved9 from "assets/images/preview.png";
import toast from "react-hot-toast";
import { baseURL } from "utils/api";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useSelector } from "react-redux";
import BasicLayout from "../components/layout";
import CircularProgress from "@mui/material/CircularProgress";

function SignIn() {
  const userTheme = useSelector((state) => state.commonSlice.theme);
  const [rememberMe, setRememberMe] = useState(true);
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [validationError, setValidationError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState("");
  const [emailActivated, setEmailActivated] = useState(false)

  useEffect(() => {
      const queryParams = new URLSearchParams(location.search);
      const tokenFromUrl = queryParams.get("token");
      if (tokenFromUrl) {
          setToken(tokenFromUrl);
      }
  }, [location]);

  const validatePassword = (password) => {
    if (password.length < 6) {
      return "Password must be at least 6 characters long";
    }
    return "";
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const error = validatePassword(password);
    if (error) {
      setValidationError(error);
      return;
    }
    setValidationError('');
    setIsLoading(true);

    fetch(`${baseURL}resetPassword?token=${token}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        newPassword: password,
        role: "BUSINESS",
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          toast.success(data.message);
          navigate("/login");
        } else {
          toast.error(data.message);
        }
      })
      .catch((err) => {
        toast.error(err.message || 'Something went wrong');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handlePasswordToggle = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <CoverLayout
      title={"Reset Password"}
      description={"Enter your new password"}
      image={curved9}
      forgot={true}>
      <SoftBox component="form" role="form" onSubmit={handleSubmit}>
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Enter New Password
            </SoftTypography>
          </SoftBox>
          <div style={{ position: "relative" }}>
            <SoftInput
              name="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setValidationError('');
              }}
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              error={!!validationError}
            />
            <div
              onClick={handlePasswordToggle}
              style={{
                position: "absolute",
                right: "10px",
                top: "60%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: userTheme === 'dark' ? 'white' : 'black'
              }}
            >
              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </div>
          </div>
          {validationError && (
            <SoftTypography
              variant="caption"
              color="error"
              sx={{ display: 'block', color: 'red' , mt: 1 }}
            >
              {validationError}
            </SoftTypography>
          )}
        </SoftBox>
         
        <SoftButton 
          type="submit" 
          variant="gradient" 
          color="info" 
          fullWidth
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size={24} sx={{ color: '#ffffff' }} />
          ) : (
            "Reset Password"
          )}
        </SoftButton>
      </SoftBox>
    </CoverLayout>
  );
}

export default SignIn;
